/*
 * @Author: RYL
 * @Description: 终端表格
 * @Date: 2020-10-22 16:46:07
 * @LastEditTime: 2022-03-05 18:38:17
 */
import i18n from "@/common/lang";
export const Columns = [
  { LabelName: i18n.t('lang.devicelist.SerialNumber'), row: 80, align: 'center', key: 0, ColumnsKey: 'Index', slot: true},
  { LabelName: '名称', key: 1, ColumnsKey: 'name', seek: 'name'},
  { LabelName: '序列号', key: 2, ColumnsKey: 'dsn', placeholder: i18n.t('lang.devicelist.search1'), sort: 'custom', seek: 'dsn'},
  { LabelName: 'did', key: 3, ColumnsKey: 'did', placeholder: i18n.t('lang.devicelist.search1'), sort: 'custom',seek:'did' },
  // { LabelName: '模板名称', key: 4, ColumnsKey: 'mid', placeholder: i18n.t('lang.devicelist.search1'), sort: 'custom' },
  { LabelName: '协议', key: 5, ColumnsKey: 'protocol',seek: 'protocol', placeholder: i18n.t('lang.devicelist.search2'), sort: 'custom', isCustom: true,seek:'protocol'  },
  // { LabelName: i18n.t('lang.devicelist.statevoid'), align: 'center', key: 6, ColumnsKey: 'state', Tag: true, placeholder: i18n.t('lang.devicelist.search5'), Fun: 'GetStatus'},
  { LabelName: '描述', key: 7, ColumnsKey: 'description', placeholder: i18n.t('lang.devicelist.search1'), sort: 'custom' },
]